// store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './StateSlice/user';

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
